import { z } from 'zod'

export const AGENTMCP_CHAT_STREAM_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpChatStreamResponseSchema = z.record(z.unknown())
export const agentmcpChatStreamRequestSchema = z.record(z.unknown())

export type AgentmcpChatStreamResponse = z.infer<typeof agentmcpChatStreamResponseSchema>
export type AgentmcpChatStreamRequest = z.infer<typeof agentmcpChatStreamRequestSchema>
